import axios from 'axios'
import store from '@/store.js'

async function callAPI(url, parameters, method='post') {
  try {
    let base=store.getters.apiBaseURL;
    if(parameters&&parameters.apiBaseUrl){
      base=parameters.apiBaseUrl
    }
    let res = await axios({
      method: method,
      url: base+'/'+url,
      data: parameters
    })
    if(typeof res.data === 'string'){
      res.data=JSON.parse(res.data.replace(new RegExp("NaN", 'g'), "null"))
    }
    return res
  } catch(e) {
    //TODO : authorize specific error codes through here so componenets can get feedback from server
    console.log(e)
  }
}
function sortFloors(floors){
  let floorArray=[...floors]
  let useString=false;
  if(floorArray[0]&&typeof(floorArray[0])==="string"){
    useString=true
    floorArray=floorArray.map(x=>x.split(">"))
  }
  let zeroFillList=["1F","2F","3F","4F","5F","6F","7F","8F","9F"]
  let doubleZeroFillList=["GF"]
  let tripleZeroFillList=["B1F","B2F","B3F","B4F","B5F","B6F","B7F","B8F","B9F"]
  floorArray.sort(function(a,b){
    let aseq=""
    let bseq=""
    for (let seg of a){
      if (zeroFillList.includes(seg)){
        aseq=aseq+"0"+seg
      } else if (doubleZeroFillList.includes(seg)){
        aseq=aseq+"00"+seg
      }else if (tripleZeroFillList.includes(seg)){
        aseq=aseq+"000"+seg
      } else {
        aseq=aseq+seg
      }
    }
    for (let seg of b){
      if (zeroFillList.includes(seg)){
        bseq=bseq+"0"+seg
      } else if (doubleZeroFillList.includes(seg)){
        bseq=bseq+"00"+seg
      } else if (tripleZeroFillList.includes(seg)){
        bseq=bseq+"000"+seg
      } else {
        bseq=bseq+seg
      }
    }
    return aseq>bseq ? 1 : -1
  })
  if(useString){
    floorArray=floorArray.map(x=>x.join(">"))
  }
  return floorArray
}

function findLineByLeastSquares(values_x, values_y) {
  let sum_x = 0;
  let sum_y = 0;
  let sum_xy = 0;
  let sum_xx = 0;
  let count = 0;
  let x = 0;
  let y = 0;
  let values_length = values_x.length;
  if (values_length != values_y.length) {
    throw new Error('The parameters values_x and values_y need to have same size!');
  }
  if (values_length === 0) {
    return [ [], [] ];
  }
  for (let v = 0; v < values_length; v++) {
    x = values_x[v];
    y = values_y[v];
    sum_x += x;
    sum_y += y;
    sum_xx += x*x;
    sum_xy += x*y;
    count++;
  }
  let m = (count*sum_xy - sum_x*sum_y) / (count*sum_xx - sum_x*sum_x);
  let b = (sum_y/count) - (m*sum_x)/count;
  return [m, b];
}

async function getStatus(id=1) {
  let res = await callAPI('status/'+id,
    {},
    'get'
    )
  return res.data
}

async function getSummary(param){
  let a = {
    agg: 'all',
    agg_op: 'sum'
  }
  a = Object.assign(a, param)
  let res= await callAPI(
    'data/',
    a
  )
  return res.data
}


async function getTimeSeries(sensor_names,
                             equipment_name='Chiller 1',
                             facility_name='HKL Prince Building',
                             date_range=null,
                             agg=null,
                             on_only=false,
                             facet=null,
                             clean_data = false,
                             apiBaseUrl = null,
                             pad_dates = false
                             ) {
  let parameters = {
      facility_name: facility_name,
      equipment_name: equipment_name,
      sensor_names: sensor_names,
      on_only: on_only,
      clean_data: clean_data
    }
  if( !!date_range) {
     parameters['date_range'] =  [date_range.start, date_range.end]
  }
  if( !!apiBaseUrl) {
     parameters.apiBaseUrl =  apiBaseUrl
  }
  if( !!pad_dates) {
     parameters.pad_dates =  pad_dates
  }
  if( !!agg){
    parameters['agg'] = agg.agg
    parameters['agg_op'] = agg.agg_op
  }
  if(!!facet) {
    parameters['facet_var'] = facet.facet_var
    parameters['facet_groups'] = facet.facet_groups
  }
  let res = await callAPI('data/',
    parameters
  )
  return res.data
}

async function getIssues(
                         equipment_name=null,
                         facility_name='HKL Prince Building',
                         date_range=null
                         ) {
  let parameters = {
      facility_name: facility_name,
      equipment_name: equipment_name
    }
  if( !!date_range) {
     parameters['date_range'] =  [date_range.start, date_range.end]
  }

  let res = await callAPI('issue/',
    parameters
  )
  if(typeof res.data === 'string'){
    return JSON.parse(res.data.replace(new RegExp("NaN", 'g'), "null"))
  }
  return res.data
}


async function getAnomalies(equipment_name,
                            facility_name,
                            date_range=null,
                            name=null,
                            summary=null
                            ) {
  let parameters = {
    facility_name: facility_name,
    equipment_name: equipment_name
  }

  if (!!date_range) {
     parameters['date_range'] =  [date_range.start, date_range.end]
  } else {
    // does not calling this api without date range (too much data)
    return null
  }

  if (!!name) {
    parameters['name'] = name
  }

  if(!!summary){
    parameters.summary=true
  }

  let res = await callAPI('anomaly/',
    parameters
    )
  return res.data
}



async function getAnomaliesSummary(equipment_name,
                            facility_name,
                            date_range=null) {
  let parameters = {
    facility_name: facility_name,
    equipment_name: equipment_name
  }

  if( !!date_range) {
     parameters['date_range'] =  [date_range.start, date_range.end]
  } else {
    // does not calling this api without date range (too much data)
    return null
  }

  let res = await callAPI('anomalysummary/',
    parameters
    )
  return res.data
}


async function getSupervisedResults(equipment_name,
                                    facility_name,
                                    date_range=null) {
  let parameters = {
    facility_name: facility_name,
    equipment_name: equipment_name
  }

  if( !!date_range) {
     parameters['date_range'] =  [date_range.start, date_range.end]
  } else {
    // does not calling this api without date range (too much data)
    return null
  }

  let res = await callAPI('supervisedresult/',
    parameters
    )
  return res.data
}



async function getControlLogicBenefits(param) {

  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('controllogic/',
    param
  )
  return res.data
}


async function getIssueSummary(param) {

  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('issuesummary/',
    param
  )
  return res.data
}


async function getMaintenanceRecords(param) {
  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('maintenancerecord/',
    param
  )
  return res.data

}


async function putMaintenanceRecord(param) {
  let res = await callAPI(
    'maintenancerecord/',
    param,
    'put'
  )
  return res.data
}


async function deleteMaintenanceRecord(param) {
  let res = await callAPI(
    'maintenancerecord/',
    param,
    'delete'
  )
  return res.data

}


async function getEquipment(param) {
  let res = await callAPI('equipment/',
    param
  )
  return res.data
}


async function putEquipment(param) {
  let res = await callAPI(
    'equipment/',
    param,
    'put'
  )
  return res.data
}


async function deleteEquipment(param) {
  let res = await callAPI(
    'equipment/',
    param,
    'delete'
  )
  return res.data
}


async function getFacility(param) {
  let res = await callAPI('facility/',
    param
  )
  return res.data

}


async function putFacility(param) {
  let res = await callAPI(
    'facility/',
    param,
    'put'
  )
  return res.data
}


async function deleteFacility(param) {
  let res = await callAPI(
    'facility/',
    param,
    'delete'
  )
  return res.data
}


async function getPoint(param) {
  let res = await callAPI('point/',
    param
  )
  return res.data

}


async function putPoint(param) {
  let res = await callAPI(
    'point/',
    param,
    'put'
  )
  return res.data
}


async function deletePoint(param) {
  let res = await callAPI(
    'point/',
    param,
    'delete'
  )
  return res.data
}


async function getConfig(param) {
  let res = await callAPI('config/',
    param
  )
  return res.data

}


async function putConfig(param) {
  let res = await callAPI(
    'config/',
    param,
    'put'
  )
  return res.data
}


async function deleteConfig(param) {
  let res = await callAPI(
    'config/',
    param,
    'delete'
  )
  return res.data
}

async function getAutotuner(param) {
  let res = await callAPI('autotuner/',
      param
  )
  return res.data

}


async function putAutotuner(param) {
  let res = await callAPI(
      'autotuner/',
      param,
      'put'
  )
  return res.data
}


async function deleteAutotuner(param) {
  let res = await callAPI(
      'autotuner/',
      param,
      'delete'
  )
  return res.data
}

async function getEquipmentRelationship(param) {
    let res = await callAPI('equipment-relationship/',
        param
    )
    return res.data

}


async function putEquipmentRelationship(param) {
    let res = await callAPI(
        'equipment-relationship/',
        param,
        'put'
    )
    return res.data
}


async function deleteEquipmentRelationship(param) {
    let res = await callAPI(
        'equipment-relationship/',
        param,
        'delete'
    )
    return res.data
}

async function getParameter(param) {
  let res = await callAPI('parameter/',
    param
  )
  return res.data

}


async function putParameter(param) {
  let res = await callAPI(
    'parameter/',
    param,
    'put'
  )
  return res.data
}


async function deleteParameter(param) {
  let res = await callAPI(
    'parameter/',
    param,
    'delete'
  )
  return res.data
}

async function getAnomalyDescription(param) {
  let res = await callAPI('anomalydescription/',
      param
  )
  return res.data

}


async function putAnomalyDescription(param) {
  let res = await callAPI(
      'anomalydescription/',
      param,
      'put'
  )
  return res.data
}


async function deleteAnomalyDescription(param) {
  let res = await callAPI(
      'anomalydescription/',
      param,
      'delete'
  )
  return res.data
}

async function getConnector(param) {
  let res = await callAPI('connector/',
      param
  )
  return res.data

}

async function putConnector(param) {
  let res = await callAPI(
      'connector/',
      param,
      'put'
  )
  return res.data
}

async function deleteConnector(param) {
  let res = await callAPI(
      'connector/',
      param,
      'delete'
  )
  return res.data
}

async function getGraphic(param) {
  let res = await callAPI('graphic/',
      param
  )
  return res.data

}

async function putGraphic(param) {
  let res = await callAPI(
      'graphic/',
      param,
      'put'
  )
  return res.data
}

async function deleteGraphic(param) {
  let res = await callAPI(
      'graphic/',
      param,
      'delete'
  )
  return res.data
}

async function getScript(param) {
  let res = await callAPI('script/',
      param
  )
  return res.data

}

async function putScript(param) {
  let res = await callAPI(
      'script/',
      param,
      'put'
  )
  return res.data
}

async function deleteScript(param) {
  let res = await callAPI(
      'script/',
      param,
      'delete'
  )
  return res.data
}

async function getScriptVersions(param) {
  let res = await callAPI('script-versions/',
      param
  )
  return res.data

}

async function testScript(param) {
  let res = await callAPI('script-test/',
      param
  )
  return res.data

}

async function getEquipmentServicingSchedule(param) {
  let res = await callAPI('equipment-servicing-schedule/',
      param
  )
  return res.data

}


async function putEquipmentServicingSchedule(param) {
  let res = await callAPI(
      'equipment-servicing-schedule/',
      param,
      'put'
  )
  return res.data
}


async function deleteEquipmentServicingSchedule(param) {
  let res = await callAPI(
      'equipment-servicing-schedule/',
      param,
      'delete'
  )
  return res.data
}

async function getDates(param) {
  let res = await callAPI('dates/',
      param
  )
  return res.data

}


async function putDates(param) {
  let res = await callAPI(
      'dates/',
      param,
      'put'
  )
  return res.data
}


async function deleteDates(param) {
  let res = await callAPI(
      'dates/',
      param,
      'delete'
  )
  return res.data
}

async function getRule(param) {
  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('rule/',
    param
  )
  return res.data

}



async function putRule(param) {
  let res = await callAPI(
    'rule/',
    param,
    'put'
  )
  return res.data
}


async function deleteRule(param) {
  let res = await callAPI(
    'rule/',
    param,
    'delete'
  )
  return res.data
}

async function getCustomViews(param) {
  let res = await callAPI('custom-view/',
      param
  )
  return res.data

}

async function getPublishedCustomViews(param) {
  let res = await callAPI('published-custom-view/',
      param
  )
  return res.data

}

async function putCustomView(param) {
  let res = await callAPI(
    'custom-view/',
    param,
    'put'
  )
  return res.data
}


async function deleteCustomView(param) {
  let res = await callAPI(
    'custom-view/',
    param,
    'delete'
  )
  return res.data
}


async function getJob(param) {
  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('job/',
    param
  )
  return res.data

}

async function getSupportedJobs(param) {
  let res = await callAPI('supported-jobs/',
      param
  )
  return res.data
}


async function putJob(param) {
  let res = await callAPI(
    'job/',
    param,
    'put'
  )
  return res.data
}


async function deleteJob(param) {
  let res = await callAPI(
    'job/',
    param,
    'delete'
  )
  return res.data
}


async function getModel(param) {
  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('model/',
    param
  )
  return res.data

}


async function putModel(param) {
  let res = await callAPI(
    'model/',
    param,
    'put'
  )
  return res.data
}


async function deleteModel(param) {
  let res = await callAPI(
    'model/',
    param,
    'delete'
  )
  return res.data
}


async function getUser(param) {
  if(process.env.VUE_APP_AUTH_ENDPOINT&&process.env.VUE_APP_AUTH_ENDPOINT!==""){
    if(!param){
      param={}
    }
    param.apiBaseUrl=process.env.VUE_APP_AUTH_ENDPOINT
  }
  let res = await callAPI('user/',
    param
  )
  return res.data

}


async function putUser(param) {
  if(process.env.VUE_APP_AUTH_ENDPOINT&&process.env.VUE_APP_AUTH_ENDPOINT!==""){
    if(!param){
      param={}
    }
    param.apiBaseUrl=process.env.VUE_APP_AUTH_ENDPOINT
  }
  let res = await callAPI(
    'user/',
    param,
    'put'
  )
  return res.data
}

async function getCurrentUser(param) {
  if(process.env.VUE_APP_AUTH_ENDPOINT&&process.env.VUE_APP_AUTH_ENDPOINT!==""){
    if(!param){
      param={}
    }
    param.apiBaseUrl=process.env.VUE_APP_AUTH_ENDPOINT
  }
  let res = await callAPI('current-user/',
      param
  )
  return res.data

}


async function putCurrentUser(param) {
  if(process.env.VUE_APP_AUTH_ENDPOINT&&process.env.VUE_APP_AUTH_ENDPOINT!==""){
    if(!param){
      param={}
    }
    param.apiBaseUrl=process.env.VUE_APP_AUTH_ENDPOINT
  }
  let res = await callAPI(
      'current-user/',
      param,
      'put'
  )
  return res.data
}

async function deleteUser(param) {
  if(process.env.VUE_APP_AUTH_ENDPOINT&&process.env.VUE_APP_AUTH_ENDPOINT!==""){
    if(!param){
      param={}
    }
    param.apiBaseUrl=process.env.VUE_APP_AUTH_ENDPOINT
  }
  let res = await callAPI(
    'user/',
    param,
    'delete'
  )
  return res.data
}


async function getReportConfig(param) {
  if( !!param.date_range) {
     param['date_range'] =  [param['date_range'].start, param['date_range'].end]
  }

  let res = await callAPI('reportconfig/',
    param
  )
  return res.data

}


async function putReportConfig(param) {
  let res = await callAPI(
    'reportconfig/',
    param,
    'put'
  )
  return res.data
}


async function deleteReportConfig(param) {
  let res = await callAPI(
    'reportconfig/',
    param,
    'delete'
  )
  return res.data
}


async function getFacilityList(param) {
  let res = await callAPI(
    'facilitylist/',
    param,
    'get'
  )
  return res.data
}

async function getEquipSummary(param) {
  let res = await callAPI(
    'summary/',
    param,
    'post'
  )
  return res.data
}


async function getSavingSummary(param) {
  let res = await callAPI(
    'savingsummary/',
    param,
    'post'
  )
  return res.data
}

async function runRuleTest(param) {
  let res = await callAPI(
      'rule-test/',
      param,
      'post'
  )
  if(typeof res.data === 'string'){
    return JSON.parse(res.data.replace(new RegExp("NaN", 'g'), "null"))
  }
  return res.data
}

async function getNotification(param) {
  let res = await callAPI(
    'notification/',
    param,
    'post'
  )
  return res.data
}

async function putNotification(param) {
  let res = await callAPI(
    'notification/',
    param,
    'put'
  )
  return res.data
}

async function getKPI(param) {
  let res = await callAPI(
    'kpi/',
    param,
    'post'
  )
  return res.data
}

async function deleteKPI(param) {
  let res = await callAPI(
      'kpi/',
      param,
      'delete'
  )
  return res.data
}

async function putKPI(param) {
  let res = await callAPI(
    'kpi/',
    param,
    'put'
  )
  return res.data
}


async function getWhiteboard(param) {
  let res = await callAPI(
    'whiteboard/',
    param,
    'post'
  )
  return res.data
}

async function putWhiteboard(param) {
  let res = await callAPI(
    'whiteboard/',
    param,
    'put'
  )
  return res.data
}

async function deleteWhiteboard(param) {
  let res = await callAPI(
    'whiteboard/',
    param,
    'delete'
  )
  return res.data
}


async function getOptimizationControl(param) {
  let res = await callAPI(
    'optimizationcontrol/',
    param,
    'post'
  )
  return res.data
}

async function putOptimizationControl(param) {
  let res = await callAPI(
    'optimizationcontrol/',
    param,
    'put'
  )
  return res.data
}

async function logEventToDB(param) {
  let res = await callAPI(
      'log-event/',
      param,
      'post'
  )
  return res.data
}


async function getResult(param) {
  let res = await callAPI(
    'result/',
    param,
    'post'
  )
  return res.data
}

async function putResult(param) {
  let res = await callAPI(
    'result/',
    param,
    'put'
  )
  return res.data
}

async function getSuggestions(param) {
  let res = await callAPI(
    'pointmapper/',
    param,
    'post'
  )
  return res.data
}

async function getCOP(param) {
  let res = await callAPI(
    'cop/',
    param,
    'post'
  )
  return res.data
}

async function getRefrigerantProp(t2=330, subcool=2, t3=300, superheat=3, eta=0.8, refri='R410a') {

  let res = await callAPI('refrigerant/',
  {
    'T2': t2,
    'subcooled_delta_t': subcool,
    'T3': t3,
    'superheat_delta_t': superheat,
    'eta_com': eta,
    'refrigerant': refri
},'post'
  )
  return res.data
}

async function login(user_name, password) {
  let params={
    user_name: user_name,
    password: password
  }
  if(process.env.VUE_APP_AUTH_ENDPOINT&&process.env.VUE_APP_AUTH_ENDPOINT!==""){
    params.apiBaseUrl=process.env.VUE_APP_AUTH_ENDPOINT
  }
  let res = await callAPI('login/',
      params
  )
  return res.data
}

function getDateTime(now) {
        var year    = now.getFullYear();
        var month   = now.getMonth()+1;
        var day     = now.getDate();
        var hour    = now.getHours();
        var minute  = now.getMinutes();
        var second  = now.getSeconds();
        if(month.toString().length == 1) {
             month = '0'+month;
        }
        if(day.toString().length == 1) {
             day = '0'+day;
        }
        if(hour.toString().length == 1) {
             hour = '0'+hour;
        }
        if(minute.toString().length == 1) {
             minute = '0'+minute;
        }
        if(second.toString().length == 1) {
             second = '0'+second;
        }
        var dateTime = year+'-'+month+'-'+day+' '+hour+':'+minute+':'+second;
         return dateTime;
    }
function uniqueid() {
  let ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  let ID_LENGTH = 20;
  let rtn = '';
  for (let i = 0; i < ID_LENGTH; i++) {
    rtn += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
  }
  return rtn;
}

import jwtDecode from 'jwt-decode'

export {findLineByLeastSquares,sortFloors,getTimeSeries, getStatus, getIssues, getControlLogicBenefits, callAPI, getAnomalies,
  getMaintenanceRecords, putMaintenanceRecord, deleteMaintenanceRecord,
  getSummary, getIssueSummary, getFacilityList, getEquipSummary, getSavingSummary,runRuleTest,
  getRule, putRule, deleteRule, getReportConfig, putReportConfig, deleteReportConfig, getAnomaliesSummary,
  getRefrigerantProp, getUser, putUser,getCurrentUser,putCurrentUser, deleteUser, getEquipment, putEquipment, deleteEquipment,
  getFacility, putFacility, deleteFacility, getPoint, putPoint, deletePoint, getConfig, putConfig, deleteConfig,
  getParameter, putParameter, deleteParameter,
  getAnomalyDescription, putAnomalyDescription, deleteAnomalyDescription,
  getConnector, putConnector, deleteConnector,
  getGraphic, putGraphic, deleteGraphic,
  getScript, putScript, deleteScript,
  getScriptVersions,
  testScript,
  getDateTime, login, jwtDecode, getNotification,
  getKPI, putKPI, deleteKPI,
  getJob, putJob, deleteJob,getSupportedJobs,
  getModel, putModel, deleteModel,
  getOptimizationControl, putOptimizationControl,
  getSupervisedResults,
  getResult, putResult,
  getCOP,
  putNotification,
  getWhiteboard, putWhiteboard, deleteWhiteboard,
  getEquipmentServicingSchedule,putEquipmentServicingSchedule,deleteEquipmentServicingSchedule,
  getCustomViews, putCustomView, deleteCustomView, getPublishedCustomViews,
  getDates, putDates, deleteDates,
  getAutotuner, putAutotuner, deleteAutotuner,
  getEquipmentRelationship, putEquipmentRelationship, deleteEquipmentRelationship,
  getSuggestions,
  logEventToDB,
  uniqueid
}
